<template>
	<div>
		<el-dialog title="提示" :visible.sync="equipmentStatus && !equipmentShowStatus && !Upgrade.status && !dialogRestoreFactory && !loading" width="400px" @close="confirm">
			<div class="tip flexJA flexFs" style="align-items: center;">
				<img src="@/assets/images/mid.png">
				<div>设备未连接</div>
			</div>
			<div class="btns flexJA flexFe">
				<div class="btn btn-1 flexJA" @click="confirm">确认</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import { Loading } from 'element-ui';
	export default {
		data() {
			return {
			}
		},
		computed: {
			...mapState({
				config: (state) => state.config,
				loading: (state) => state.loading,
				Upgrade: (state) => state.Upgrade,
				equipmentStatus: (state) => state.equipmentStatus,
				equipmentShowStatus: (state) => state.equipmentShowStatus,
				dialogRestoreFactory: (state) => state.dialogRestoreFactory,
			}),
		},
		methods: {
			confirm() {
				this.$store.commit('gotState', {key: 'equipmentStatus', data: false})
			}
		}
	}
</script>

<style scoped lang="scss">
	@import '@/assets/css/deep.scss';
</style>